/* eslint-disable no-bitwise */
// ConfigureButtons.jsx
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import {
  fromC,
  valveTimeToEpochMillis,
} from 'altrac-conversions'
import { SpeedometerOn } from '../Graphics/Speedometer'
import SettingHistoryGraphic from '../Graphics/SettingHistory'
import FuelMeter from '../Graphics/FuelMeter'

import {
  TextLink,
} from '../Navigation/Buttons'
import {
  isNumber,
} from '../Inputs/Inputs'

import AppStore from '../../../stores/AppStore'

import styles from '../../../../css/devicePage.module.css'

const ConfigureButtons = ({
  applicationSettings = { settings: {} },
  applicationSettingsNew = { settings: {} },
  reading0,
  physical,
  interfaceVersioned,
  path,
  settingTypes = [],
}) => {
  if (settingTypes.length < 1) {
    return (
      <section />
    )
  }
  let i = 0
  const settingsCode = []

  const level = AppStore.getUser()?.permissions?.level || 0
  let pathReturn = null
  if (level >= 10) {
    pathReturn = path
  }
  const {
    status,
    settings: {
      schedules,
    } = {},
  } = applicationSettingsNew

  for (i = 0; i < settingTypes.length; i += 1) {
    const settingTypesItem = settingTypes[i]
    let settingType = ''
    if (settingTypesItem && typeof settingTypesItem === 'string') {
      settingType = settingTypesItem
    } else if (settingTypesItem && typeof settingTypesItem === 'object' && typeof settingTypesItem.type === 'string') {
      settingType = settingTypesItem.type
    }
    switch (settingType) {
      case 'settlingTime':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}settlingTime` : null} key={settingType}>
            <AppConfigureSettlingTime
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
            />
          </Link>
        )
        break
      case 'sleepInterval':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}sleepInterval` : null} key={settingType}>
            <AppConfigureSleepInterval
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
            />
          </Link>
        )
        break
      case 'update':
        // replaced with a sleep and update combined button
        break
      case 'temperatureSet':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}tempSet` : null} key={settingType}>
            <AppConfigureTemperature
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              reading0={reading0}
              physical={physical}
            />
          </Link>
        )
        break
      case 'rpmTarget':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}rpmTarget` : null} key={settingType}>
            <AppConfigureRpmTarget
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              reading0={reading0}
              physical={physical}
            />
          </Link>
        )
        break
      case 'settingHistory': {
        const settingHistoryPath = typeof pathReturn === 'string' ? pathReturn.replace('/settings', '') : pathReturn
        settingsCode.push(
          <Link to={pathReturn ? `${settingHistoryPath}settingHistory` : null} key={settingType}>
            <AppConfigureSettingHistory />
          </Link>
        )
      }
        break
      case 'calibrate':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}calibrate` : null} key={settingType}>
            <AppConfigureCalibrate
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              reading0={reading0}
              physical={physical}
            />
          </Link>
        )
        break
      case 'timeSet':
        settingsCode.push(
          <AppConfigureTimeSet
            applicationSettings={applicationSettings}
            applicationSettingsNew={applicationSettingsNew}
            physical={physical}
            interfaceV={interfaceVersioned}
            path={pathReturn}
            key={settingType}
          />
        )
        break
      case 'run':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}run` : null} key={settingType}>
            <AppConfigureRun
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
            />
          </Link>
        )
        break
      case 'application':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}application` : null} key={settingType}>
            <AppConfigureApplication
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='application'
            />
          </Link>
        )
        break
      case 'application1':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}application1` : null} key={settingType}>
            <AppConfigureApplication
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='application1'
            />
          </Link>
        )
        break
      case 'application2':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}application2` : null} key={settingType}>
            <AppConfigureApplication
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='application2'
            />
          </Link>
        )
        break
      case 'schedule':
        settingsCode.push(
          <TextLink
            text='SCHEDULE PUMP'
            path={pathReturn ? `${pathReturn}schedule` : `${path}schedule`}
            key={settingType}
            className={status === 'new' && Array.isArray(schedules) ? styles.newSettings : ''}
          />
        )
        break
      case 'schedule1':
        settingsCode.push(
          <TextLink
            text='SCHEDULE RELAY 1'
            path={pathReturn ? `${pathReturn}schedule/1` : `${path}schedule/1`}
            key={settingType}
            className={status === 'new' && Array.isArray(schedules) ? styles.newSettings : ''}
          />
        )
        break
      case 'schedule2':
        settingsCode.push(
          <TextLink
            text='SCHEDULE RELAY 2'
            path={pathReturn ? `${pathReturn}schedule/2` : `${path}schedule/2`}
            key={settingType}
            className={status === 'new' && Array.isArray(schedules) ? styles.newSettings : ''}
          />
        )
        break
      case 'modemReplacement':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}modemReplacement` : null} key={settingType}>
            <AppConfigureModemReplacement />
          </Link>
        )
        break
      case 'dataDetails':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}dataDetails` : null} key={settingType}>
            <AppConfigureDataDetails />
          </Link>
        )
        break
      case 'flowSettings':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}flowSettings` : null} key={settingType}>
            <AppConfigureFlowSettings />
          </Link>
        )
        break
      case 'pump2Application':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}pump2Application` : null} key={settingType}>
            <AppConfigurePump2Application
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='pump2Application'
            />
          </Link>
        )
        break
      case 'pump2Logic':
      case 'pump2Logic1':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}pump2Logic1` : null} key={settingType}>
            <AppConfigurePump2Logic
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='pump2Logic1'
            />
          </Link>
        )
        break
      case 'pump2Logic2':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}pump2Logic2` : null} key={settingType}>
            <AppConfigurePump2Logic
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='pump2Logic2'
            />
          </Link>
        )
        break
      case 'pump2Inputs':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}pump2Inputs` : null} key={settingType}>
            <AppConfigurePump2Inputs
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='pump2Inputs'
            />
          </Link>
        )
        break

      case 'valveInputs':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}valveInputs` : null} key={settingType}>
            <AppConfigureValveInputs
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='valveInputs'
            />
          </Link>
        )
        break
      case 'pump2Flow':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}pump2Flow` : null} key={settingType}>
            <AppConfigurePump2Flow
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='pump2Flow'
            />
          </Link>
        )
        break
      case 'pump2Communications':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}pump2Communications` : null} key={settingType}>
            <AppConfigurePump2Communications
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='pump2Communications'
            />
          </Link>
        )
        break

      case 'fuelSensorControl':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}fuelSensorControl` : null} key={settingType}>
            <AppConfigureFuelSensorControl
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='fuelSensorControl'
            />
          </Link>
        )
        break
      case 'windMachine':
        settingsCode.push(
          <Link to={pathReturn ? `${pathReturn}windMachine` : null} key={settingType}>
            <AppConfigureWindMachine
              applicationSettings={applicationSettings}
              applicationSettingsNew={applicationSettingsNew}
              physical={physical}
              valueKey='windMachine'
            />
          </Link>
        )
        break
      case 'heading':
        if (settingTypesItem.label && typeof settingTypesItem.label === 'string') {
          settingsCode.push(
            <h4 style={{ marginTop: '25px' }} className={styles.sectionName}>
              {settingTypesItem.label}
            </h4>
          )
        }
        break
      default:
    }
  }

  return (
    <section>
      <ul>
        {settingsCode}
      </ul>
    </section>
  )
}


ConfigureButtons.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
  interfaceVersioned: PropTypes.object,
  reading0: PropTypes.object,
  physical: PropTypes.object,
  path: PropTypes.string,
  settingTypes: PropTypes.array,
}

const AppConfigureTemperature = function AppConfigureTemperature ({
  applicationSettings = { settings: {} },
  applicationSettingsNew = { settings: {} },
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let tempStart = 0
  if (testSettingsNew && isNumber(applicationSettingsNew.settings.tempStart) && applicationSettingsNew.status === 'new') {
    tempStart = applicationSettingsNew.settings.tempStart
  } else if (testSettings && isNumber(applicationSettings.settings.tempStart)) {
    tempStart = applicationSettings.settings.tempStart
  }

  let tempStop = 1.6667
  if (testSettingsNew && isNumber(applicationSettingsNew.settings.tempStop) && applicationSettingsNew.status === 'new') {
    tempStop = applicationSettingsNew.settings.tempStop
  } else if (testSettings && isNumber(applicationSettings.settings.tempStop)) {
    tempStop = applicationSettings.settings.tempStop
  }

  const tempConv = AppStore.getData().user?.locale?.tempConv
  tempStart = fromC(tempStart, tempConv, 1)
  tempStart = tempStart === null ? tempStart = 'Error' : tempStart.toFixed(1)
  tempStop = fromC(tempStop, tempConv, 1)
  tempStop = tempStop === null ? tempStop = 'Error' : tempStop.toFixed(1)
  let newTempSet = false

  if (applicationSettingsNew && applicationSettingsNew.status === 'new') {
    if (Object.prototype.hasOwnProperty.call(applicationSettingsNew.settings, 'tempStart')) {
      newTempSet = true
    }
    if (Object.prototype.hasOwnProperty.call(applicationSettingsNew.settings, 'tempStop')) {
      newTempSet = true
    }
  }

  let settingButtonStyle = styles.settingButton
  if (newTempSet) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-thermometer-quarter' />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.tempStart'
          defaultMessage='Start Temperature:'
          description='Start Temperature label'
          tagName='h5'
        />
        <FormattedMessage
          id='setting.tempStop'
          defaultMessage='Stop Temperature:'
          description='Stop Temperature label'
          tagName='h5'
        />
      </div>
      <div className={styles.settingValue}>
        <h5 className='tempStartValue'>
          {`${tempStart}°`}
        </h5>
        <h5 className='tempStopValue'>
          {`${tempStop}°`}
        </h5>
      </div>
    </div>
  )
}

AppConfigureTemperature.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureCalibrate = function AppConfigureCalibrate ({
  applicationSettings,
  applicationSettingsNew,
}) {
  let calibrate1 = 100
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  if (testSettingsNew && isNumber(applicationSettingsNew.settings.calibrate1) && applicationSettingsNew.status === 'new') {
    calibrate1 = applicationSettingsNew.settings.calibrate1
  } else if (testSettings && isNumber(applicationSettings.settings.calibrate1)) {
    calibrate1 = applicationSettings.settings.calibrate1
  }
  let calibrate2 = 200
  if (testSettingsNew && isNumber(applicationSettingsNew.settings.calibrate2) && applicationSettingsNew.status === 'new') {
    calibrate2 = applicationSettingsNew.settings.calibrate2
  } else if (testSettings && isNumber(applicationSettings.settings.calibrate2)) {
    calibrate2 = applicationSettings.settings.calibrate2
  }

  calibrate1 = calibrate1.toFixed(1)
  calibrate2 = calibrate2.toFixed(1)
  let newCalibrate = false

  if (applicationSettingsNew && applicationSettingsNew.status === 'new') {
    if (Object.prototype.hasOwnProperty.call(applicationSettingsNew.settings, 'calibrate1')) {
      newCalibrate = true
    }
    if (Object.prototype.hasOwnProperty.call(applicationSettingsNew.settings, 'calibrate2')) {
      newCalibrate = true
    }
  }

  let settingButtonStyle = styles.settingButton
  if (newCalibrate) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-wrench' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.calibrate.1'
          defaultMessage='Calibrate 1:'
          description='Calibrate 1 label'
          tagName='h5'
        />
        <FormattedMessage
          id='setting.calibrate.2'
          defaultMessage='Calibrate 2:'
          description='Calibrate 2 label'
          tagName='h5'
        />
      </div>
      <div className={styles.settingValue}>
        <h5>
          {`${calibrate1}`}
        </h5>
        <h5>
          {`${calibrate2}`}
        </h5>
      </div>
    </div>
  )
}

AppConfigureCalibrate.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureTimeSet = function AppConfigureTimeSet ({
  applicationSettings,
  applicationSettingsNew,
  interfaceV,
  path,
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  const {
    data: {
      other: {
        valveNumber = 1,
      } = {},
    },
  } = interfaceV || {}
  let newTimes = false
  let valveTimes = []
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    Object.prototype.hasOwnProperty.call(applicationSettingsNew.settings, 'valveTime')
  ) {
    newTimes = true
    valveTimes = applicationSettingsNew.settings.valveTime
  } else if (
    testSettings &&
    Object.prototype.hasOwnProperty.call(applicationSettings.settings, 'valveTime')
  ) {
    valveTimes = applicationSettings.settings.valveTime
  }

  let settingButtonStyle = styles.settingButton
  if (newTimes) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  if (valveTimes.length < 1 && path !== null) {
    return null
  }

  const timeSetHtml = []
  for (let i = 0; i < valveTimes.length; i += 2) {
    const start = valveTimes[i]
    const stop = valveTimes[i + 1]
    const startValveNumber = ((start >> 28) & 0x7) >>> 0
    const stopValveNumber = ((stop >> 28) & 0x7) >>> 0
    if (valveNumber !== startValveNumber && valveNumber !== stopValveNumber) continue

    const startMillis = valveTimeToEpochMillis(start)
    const stopMillis = valveTimeToEpochMillis(stop)
    const startPretty = ` ${moment(startMillis).format('M/DD/YY ddd h:mm A')} - ${moment(stopMillis).format('ddd h:mm A')}`

    const runTimeValue = stopMillis - startMillis
    const duration = moment.duration(stopMillis - startMillis, 'milliseconds')

    let runTime = ` ${duration.hours()} Hr ${duration.minutes()} Min`
    if (runTimeValue < 60000 || !runTime) {
      runTime = 'N/A'
    }

    if (stopMillis > (new Date()).getTime()) {
      let timeHtml
      if (runTimeValue > 0) {
        timeHtml = (
          <div className={settingButtonStyle} key={i} style={{ boxShadow: '1px 1px 5px 1px rgb(0,0,0,0.50)', position: 'relative' }}>
            <div className={styles.settingValueLongLeft}>
              <h5>
                {startPretty}
              </h5>
              <h5>
                {runTime}
              </h5>
            </div>
          </div>
        )
      }
      timeSetHtml.push(
        <Link to={path ? `${path}timeSet/${(i / 2) + 1}` : null} key={`timeSet${i}`}>
          {timeHtml}
        </Link>
      )
    }
  }

  return (<div>{timeSetHtml}</div>)
}

AppConfigureTimeSet.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
  interfaceV: PropTypes.object,
  path: PropTypes.string,
}

const AppConfigureSettlingTime = function AppConfigureSettlingTime ({
  applicationSettings,
  applicationSettingsNew,
}) {
  const { settings: { settlingTime = 5 } = {} } = applicationSettings
  const { status = 'onDevice', settings: { settlingTime: newSettlingTime, update: newUpdate } = {} } = applicationSettingsNew

  const newTime = status === 'new' && (newSettlingTime !== undefined || newUpdate !== undefined)

  let settingButtonStyle = styles.settingButton
  if (newTime) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-upload' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.settlingTime.label'
          defaultMessage='Settling Time'
          description='Settling time label'
          tagName='h5'
        />
        <FormattedMessage
          id='setting.update.label'
          defaultMessage='Update:'
          description='Update label'
          tagName='h5'
        />
      </div>
      <div className={styles.settingValue}>
        <h5>
          <FormattedMessage
            id='units.minutes'
            defaultMessage='minutes'
            description='minutes short'
          >
            {settlingTime}
          </FormattedMessage>
        </h5>
      </div>
    </div>
  )
}

AppConfigureSettlingTime.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureSleepInterval = function AppConfigureSleepInterval ({
  applicationSettings,
  applicationSettingsNew,
}) {
  const { settings: { sleepInterval = 900, update = 0 } = {} } = applicationSettings
  const { status = 'onDevice', settings: { sleepInterval: newSleepInterval, update: newUpdate } = {} } = applicationSettingsNew

  const newSleep = status === 'new' && (newSleepInterval !== undefined || newUpdate !== undefined)

  const scale = (x) => Math.round(x / 60)
  const sleepIntervalRender = (scale(newSleepInterval) || scale(newSleepInterval) === 0) ? scale(newSleepInterval) : scale(sleepInterval)
  const updateRender = Number(newUpdate == 0 || newUpdate == 1 ? newUpdate : update)

  let settingButtonStyle = styles.settingButton
  if (newSleep) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-upload' />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.sleep.label'
          defaultMessage='Sleep Time:'
          description='Sleep time label'
          tagName='h5'
        />
        <FormattedMessage
          id='setting.update.label'
          defaultMessage='Update:'
          description='Update label'
          tagName='h5'
        />
      </div>
      <div className={styles.settingValue}>
        <h5 className='sleepIntervalValue'>
          <FormattedMessage
            id='units.minutes.short'
            defaultMessage='min'
            description='minutes short'
          >
            {(txt) => (
              `${sleepIntervalRender} ${txt}`
            )}
          </FormattedMessage>
        </h5>
        <h5 className='updateValue'>
          {`${updateRender ? 'ON' : 'OFF'}`}
        </h5>
      </div>
    </div>
  )
}

AppConfigureSleepInterval.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureRun = function AppConfigureRun ({
  applicationSettings,
  applicationSettingsNew,
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newRun = false
  let currentVal = 'Stop'
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty('run')
  ) {
    newRun = true
    currentVal = applicationSettingsNew.settings.run ? 'Run' : 'Stop'
  } else if (
    testSettings &&
    applicationSettings.settings.hasOwnProperty('sleepInterval')
  ) {
    currentVal = applicationSettings.settings.run ? 'Run' : 'Stop'
  }

  let settingButtonStyle = styles.settingButton
  if (newRun) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-power-off' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.state'
          defaultMessage='State:'
          description='State label'
          tagName='h5'
        />
      </div>
      <div className={styles.settingValue}>
        <h5>
          {` ${currentVal}`}
          {
            currentVal === 'Run'
              ? (
                <FormattedMessage
                  id='general.run'
                  defaultMessage='Run'
                  description='Run'
                />
                )
              : (
                <FormattedMessage
                  id='general.stop'
                  defaultMessage='Stop'
                  description='Stop'
                />
                )
          }
        </h5>
      </div>
    </div>
  )
}

AppConfigureRun.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureApplication = function AppConfigureApplication ({
  applicationSettingsNew,
  valueKey,
}) {
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty(valueKey)
  ) {
    newApplication = true
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-arrow-circle-o-up' />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.application'
          defaultMessage='Application'
          description='Application label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigureApplication.propTypes = {
  applicationSettingsNew: PropTypes.object,
  valueKey: PropTypes.string,
}

const AppConfigurePump2Inputs = function AppConfigurePump2Inputs ({
  applicationSettingsNew,
}) {
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    (
      applicationSettingsNew.settings.hasOwnProperty('io_dig_1') ||
      applicationSettingsNew.settings.hasOwnProperty('io_dig_2') ||
      applicationSettingsNew.settings.hasOwnProperty('io_dig_3') ||
      applicationSettingsNew.settings.hasOwnProperty('io_accessory') ||
      applicationSettingsNew.settings.hasOwnProperty('io_r1_feedback') ||
      applicationSettingsNew.settings.hasOwnProperty('io_r2_feedback') ||
      applicationSettingsNew.settings.hasOwnProperty('io_analog_sensor')
    )
  ) {
    newApplication = true
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.pump.inputs'
          defaultMessage='Inputs'
          description='Input Settings label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigurePump2Inputs.propTypes = {
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureValveInputs = function AppConfigureValveInputs ({
  applicationSettingsNew,
}) {
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    (
      applicationSettingsNew.settings.hasOwnProperty('io_r1_feedback') ||
      applicationSettingsNew.settings.hasOwnProperty('io_r2_feedback')
    )
  ) {
    newApplication = true
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.valve.inputs'
          defaultMessage='Inputs'
          description='Input Settings label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigureValveInputs.propTypes = {
  applicationSettingsNew: PropTypes.object,
}

const AppConfigurePump2Logic = function AppConfigurePump2Logic ({
  applicationSettings,
  applicationSettingsNew,
  valueKey,
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty(valueKey)
  ) {
    newApplication = true
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      {valueKey === 'pump2Logic1'
        ? (
          <div className={styles.settingName}>
            <FormattedMessage
              id='setting.pump.logic.1'
              defaultMessage='Device Logic Relay 1'
              description='Device Logic Relay 1 label'
              tagName='h5'
            />
          </div>
          )
        : (
          <div className={styles.settingName}>
            <FormattedMessage
              id='setting.pump.logic.2'
              defaultMessage='Device Logic Relay 2'
              description='Device Logic Relay 2 label'
              tagName='h5'
            />
          </div>
          )}

    </div>
  )
}

AppConfigurePump2Logic.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
  valueKey: PropTypes.string,
}

const AppConfigureModemReplacement = function AppConfigureModemReplacement () {
  return (
    <div className={styles.settingButton}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.modemReplacement.replacement'
          defaultMessage='Modem Replacement'
          description='Modem Replacement label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

const AppConfigureDataDetails = function AppConfigureDataDetails () {
  return (
    <div className={styles.settingButton}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.dataDetails.replacement'
          defaultMessage='Data Details'
          description='Data Details label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

const AppConfigureFlowSettings = function AppConfigureFlowSettings () {
  return (
    <div className={styles.settingButton}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.flowMeter.settings'
          defaultMessage='Flow Meter Settings'
          description='Flow Meter Settingslabel'
          tagName='h5'
        />
      </div>
    </div>
  )
}

const AppConfigurePump2Application = function AppConfigurePump2Application ({
  applicationSettings,
  applicationSettingsNew,
}) {
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    (applicationSettingsNew.settings.hasOwnProperty('application1') || applicationSettingsNew.settings.hasOwnProperty('application2'))
  ) {
    newApplication = true
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.pump.application'
          defaultMessage='Applications'
          description='Application Settings label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigurePump2Application.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigurePump2Flow = function AppConfigurePump2Flow () {
  return (
    <div className={styles.settingButton}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.pump.flow'
          defaultMessage='Flow Meter'
          description='Flow Settings label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

const AppConfigurePump2Communications = function AppConfigurePump2Communications ({
  applicationSettings,
  applicationSettingsNew,
}) {
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty('com_source')
  ) {
    newApplication = true
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <i className='fa fa-sliders' />
      </div>
      <div className={styles.settingName}>
        <FormattedMessage
          id='setting.pump.communications'
          defaultMessage='Communication'
          description='Communications Settings label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigurePump2Communications.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
}

const AppConfigureWindMachine = function AppConfigureWindMachine ({
  applicationSettings,
  applicationSettingsNew,
  physical,
  valueKey,
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  let currentVal = 0
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty(valueKey)
  ) {
    newApplication = true
    currentVal = applicationSettingsNew.settings[valueKey]
  } else if (
    testSettings &&
    applicationSettings.settings.hasOwnProperty(valueKey)
  ) {
    currentVal = applicationSettings.settings[valueKey]
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <SpeedometerOn />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.windMachine.calibration.label'
          defaultMessage='RPM Calibration'
          description='RPM Calibration label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigureWindMachine.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
  physical: PropTypes.object,
  valueKey: PropTypes.string,
}

const AppConfigureRpmTarget = function AppConfigureRpmTarget ({
  applicationSettings,
  applicationSettingsNew,
  physical,
  valueKey,
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  let currentVal = 0
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty(valueKey)
  ) {
    newApplication = true
    currentVal = applicationSettingsNew.settings[valueKey]
  } else if (
    testSettings &&
    applicationSettings.settings.hasOwnProperty(valueKey)
  ) {
    currentVal = applicationSettings.settings[valueKey]
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  let intendedSetting = 0
  let settingStatusNew = 0

  if (
    applicationSettingsNew &&
    applicationSettingsNew.settings &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.speed
  ) {
    intendedSetting = applicationSettingsNew.settings.speed
    settingStatusNew = 1
  } else if (
    applicationSettings &&
    applicationSettings.settings &&
    applicationSettings.settings.speed
  ) {
    intendedSetting = applicationSettings.settings.speed
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <SpeedometerOn color={settingStatusNew ? '#D00000' : '#284047'} />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`} style={{ color: settingStatusNew ? '#D00000' : '#284047' }}>
        <FormattedMessage
          id='setting.speed.target.label'
          defaultMessage='RPM Target'
          description='RPM Target label'
          tagName='h5'
        />
      </div>
      <div className={styles.settingValue} style={{ color: settingStatusNew ? '#D00000' : '#284047' }}>
        <h5 className='rpmTargetValue'>{intendedSetting}</h5>
      </div>
    </div>
  )
}

AppConfigureRpmTarget.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
  physical: PropTypes.object,
  valueKey: PropTypes.string,
}

const AppConfigureSettingHistory = function AppConfigureSettingHistory () {
  return (
    <div className={styles.settingButton}>
      <div className={`${styles.settingIcon} ${styles.settingHistoryGraphic}`}>
        <SettingHistoryGraphic />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.history.label'
          defaultMessage='Settings History'
          description='Settings History label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

const AppConfigureFuelSensorControl = function AppConfigureFuelSensorControl ({
  applicationSettings,
  applicationSettingsNew,
  physical,
  valueKey,
}) {
  const testSettings = applicationSettings && applicationSettings.settings
  const testSettingsNew = applicationSettingsNew && applicationSettingsNew.settings
  let newApplication = false
  let currentVal = 0
  if (
    testSettingsNew &&
    applicationSettingsNew.status === 'new' &&
    applicationSettingsNew.settings.hasOwnProperty(valueKey)
  ) {
    newApplication = true
    currentVal = applicationSettingsNew.settings[valueKey]
  } else if (
    testSettings &&
    applicationSettings.settings.hasOwnProperty(valueKey)
  ) {
    currentVal = applicationSettings.settings[valueKey]
  }

  let settingButtonStyle = styles.settingButton
  if (newApplication) {
    settingButtonStyle = `${styles.settingButton} ${styles.newSettings}`
  }

  return (
    <div className={settingButtonStyle}>
      <div className={styles.settingIcon}>
        <FuelMeter />
      </div>
      <div className={`${styles.settingName} ${styles.settingButtonCenter}`}>
        <FormattedMessage
          id='setting.fuel'
          defaultMessage='Fuel Sensor Calibration'
          description='Fuel Sensor Calibration label'
          tagName='h5'
        />
      </div>
    </div>
  )
}

AppConfigureFuelSensorControl.propTypes = {
  applicationSettings: PropTypes.object,
  applicationSettingsNew: PropTypes.object,
  physical: PropTypes.object,
  valueKey: PropTypes.string,
}

export default ConfigureButtons
